import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Вам предодобрен заём от ПолеФинанс',
  description: 'Без ежемесячных платежей, выдача за 5 рабочих дней',
  button: 'Подробнее',
  logo: 'Логотип "Поле Финанс"',
} satisfies TMessages
